import { Component, OnInit, Input, ViewChild, ElementRef, SimpleChanges, OnChanges, Output } from '@angular/core';
import { NgxFfmService } from './ngx-ffm.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmDialogComponent } from './components/dialogs/confirm-dialog/confirm-dialog.component';
import { Files } from './models/file';

export class Documents {
  owner?: any;
  group?: any;
  size?: any;
  mt?: any;
  filename?: any;
}

@Component({
  selector: 'ngx-ffm',
  templateUrl: './ngx-ffm.component.html',
  styleUrls: ['./ngx-ffm.component.scss']
})
export class NgxFfmComponent implements OnInit, OnChanges {

  file: Files;
  errorMessage = '';
  tablewidth = 100;
  dsDocuments;
  sid;
  arrDocumentsCopy = [];
  arrDocuments = [];
  arrSelectedDocuments = [];
  arrDocumentDetails = [];
  noDataUserDocuments = false;
  displayDocumentsColumns = ['cbox', 'filename', 'created_at', 'btn'];
  group;
  fileName;
  lastModified;
  size;
  fileEvent;
  base64;
  arrSelectedFiles = [];
  uploadResponse = { status: '', message: '', filePath: '' };
  error: string;

  load = false;

  // roles

  constructor(
    public ngxFfmService: NgxFfmService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
  ) { }

  @ViewChild('sortDocuments') sortDocuments: MatSort;
  @ViewChild('inputFile') inputFile: ElementRef;
  ngOnInit() {
   // this.file = new File(this.input);
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.arrDocumentsCopy = [];
    this.arrDocuments = [];
    //this.file = new File(this.input);
  }

  btnRefresh_Click() {
  }

  slDocument_Selected(event, element) {
    if (event.checked) {
      this.arrSelectedDocuments.push(element.filename);
      this.arrDocumentDetails.push(element);
    } else {
      const index = this.arrSelectedDocuments.indexOf(element.filename);
      const indexDoc = this.arrDocumentDetails.indexOf(this.arrDocumentDetails.find(x => x.filename === element.filename));
      this.arrSelectedDocuments.splice(index, 1);
      this.arrDocumentDetails.splice(indexDoc, 1);
    }

    this.arrDocuments.forEach(data => {
      if (element.filename === data.filename) {
        data.select = event.checked;
      }
    });

    if (this.arrDocumentDetails.length === 0) {
      this.tablewidth = 100;
    } else {
      this.tablewidth = 70;
    }
  }



  rowSelected(element) {
    const select = !element.select;

    this.arrDocuments.forEach(data => {
      if (element.filename === data.filename) {
        data.select = select;
      }
    });

    if (select) {
      this.arrSelectedDocuments.push(element.filename);
      this.arrDocumentDetails.push(element);
    } else {
      const index = this.arrSelectedDocuments.indexOf(element.filename);
      const indexDoc = this.arrDocumentDetails.indexOf(this.arrDocumentDetails.find(x => x.filename === element.filename));
      this.arrSelectedDocuments.splice(index, 1);
      this.arrDocumentDetails.splice(indexDoc, 1);
    }
    if (this.arrDocumentDetails.length === 0) {
      this.tablewidth = 100;
    } else {
      this.tablewidth = 70;
    }

    this.dsDocuments = new MatTableDataSource(JSON.parse(JSON.stringify(this.arrDocuments)));
  }

  

  openSnackBar(message: string, action: string) {
    this.snackbar.open(message, action, {
      duration: 2000,
      panelClass: ['blue-snackbar'],

    });
  }

}
